<app-main-layout [isHome]="isHome">
  <div class="bidder_layout">
    <app-bidderNavbar></app-bidderNavbar>
      <router-outlet></router-outlet>
     <app-biderFooter></app-biderFooter>
  </div>
</app-main-layout>